import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import { ProjectList } from "./ProjectList";
import {
  type ProjectListDataProps,
  projectListDataSchema,
} from "./ProjectList.schema";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    "project-list": { props: ProjectListDataProps; handle: undefined };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-project-list": HTMLElement;
  }
}

export function RWCProjectList({ type }: ProjectListDataProps): JSX.Element {
  return <ProjectList type={type} />;
}

componentManager.register(
  rwc("project-list", {
    component: RWCProjectList,
    dataSchema: projectListDataSchema,
  }),
);
